import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import { openFinsus } from 'utils/events';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_FINSUS } from 'constants/featureGates';
import { ROUTE_PATH } from 'routes';
import './styles.scss';

const Finsus = () => {
  const finsusEnabled = useFeatureGate(FEATURE_FINSUS);

  useEffect(() => {
    if (finsusEnabled) {
      openFinsus();
    }
  }, [finsusEnabled]);

  // En navegador no hay bridge a la app Finsus — redirige a Home.
  if (!finsusEnabled) {
    return <Navigate to={ROUTE_PATH.HOME} replace />;
  }

  return (
    <Layout
      bottomMenu
      onBack
    >
      <AppShell variant='default'>
        <h1>FINSUS</h1>
      </AppShell>
    </Layout>
  );
};

export default Finsus;
